import { Pencil } from 'lucide-react'
import type { ReactNode } from 'react'

export function EditOverlay({
  children,
  editable = true,
  editing = false,
  onEdit,
}: {
  children: ReactNode
  editable?: boolean
  editing?: boolean
  onEdit?: () => void
}) {
  if (!editable) return <>{children}</>

  return (
    <div className="group relative">
      {children}
      {!editing && (
        <button
          type="button"
          onClick={onEdit}
          className="absolute right-3 top-3 flex size-7 items-center justify-center rounded-md border border-[#f97316]/30 bg-[#f97316]/10 text-[#f97316]/70 transition-colors hover:border-[#f97316]/50 hover:bg-[#f97316]/20 hover:text-[#f97316]"
        >
          <Pencil className="size-3" />
        </button>
      )}
    </div>
  )
}
